var _excluded = ["type", "level"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { ELEMENT_DEFAULT, getLastNode, queryNode, insertNodes } from '@udecode/plate-common';
import { getPlatePluginType, getPlatePluginWithOverrides } from '@udecode/plate-core';
import { Path } from 'slate';

/**
 * Add a trailing block when the last node type is not `type` and when the editor has .
 */
var withTrailingBlock = function withTrailingBlock() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _type = _ref.type,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    query = _objectWithoutProperties(_ref, _excluded);
  return function (editor) {
    var normalizeNode = editor.normalizeNode;
    var type = _type !== null && _type !== void 0 ? _type : getPlatePluginType(editor, ELEMENT_DEFAULT);
    editor.normalizeNode = function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        currentNode = _ref3[0],
        currentPath = _ref3[1];
      if (!currentPath.length) {
        var lastChild = getLastNode(editor, level);
        var lastChildNode = lastChild === null || lastChild === void 0 ? void 0 : lastChild[0];
        if (!lastChildNode || lastChildNode.type !== type && queryNode(lastChild, query)) {
          var at = lastChild ? Path.next(lastChild[1]) : [0];
          insertNodes(editor, {
            type: type,
            children: [{
              text: ''
            }]
          }, {
            at: at
          });
          return;
        }
      }
      return normalizeNode([currentNode, currentPath]);
    };
    return editor;
  };
};
/**
 * @see {@link withTrailingNode}
 */

var createTrailingBlockPlugin = getPlatePluginWithOverrides(withTrailingBlock);
export { createTrailingBlockPlugin, withTrailingBlock };